// extracted by mini-css-extract-plugin
module.exports = {"container":"i_eE","item":"i_eF","sign":"i_eG","left":"i_eH","right":"i_eI","tick":"i_eJ","heading":"i_eK","label":"i_eL","value":"i_eM","suffix":"i_eN"};